export const termMatchesSpecimen = (
  term: string,
  siteOrSource: string,
  dashed = false
) => {
  // TODO: check performance here, this is "technically superior"
  // to just siteOrSource.includes(term), but it might not matter

  let sanitizedTerm = term.replaceAll(/[^\w -]/g, "");

  const left = sanitizedTerm.toLowerCase().startsWith("left ");
  const right = sanitizedTerm.toLowerCase().startsWith("right ");

  if (left) sanitizedTerm = sanitizedTerm.replace(/left /i, "").trim();
  if (right) sanitizedTerm = sanitizedTerm.replace(/right /i, "").trim();

  const regex = new RegExp(
    `(?:^|\\s|,${dashed ? "|-" : ""})(${
      left ? "(?:left|lt).* +" : right ? "(?:right|rt).* +" : ""
    }${sanitizedTerm})(?:$|\\s|,${dashed ? "|-" : ""})`,
    "i"
  );
  return regex.test(siteOrSource);
};

export const searchTermsOverSpecimenSite = (
  terms: string[],
  specimenSite: string
) => {
  const result = terms.find((term) => termMatchesSpecimen(term, specimenSite));

  // If we found a result around the first time, return it
  if (result) return result;

  // If we didn't and the site includes a dash, look over the terms again
  // But be lienient for dashes. This is so we can fit terms *with* dashes
  // ... the first time, but find terms broken up by dashes the second time
  // ... (if they exist). Examples include C-spine / Spine, etc. See tests.
  if (specimenSite.includes("-"))
    return terms.find((term) => termMatchesSpecimen(term, specimenSite, true));

  // Otherwise, no return, return undefined as per `.find()`
  return undefined;
};
